import '../../scss/pages/category.scss';